import { jsxs, jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import { TodoDataTestIds } from "../../constants/dataTestIds.js";
import { useTodoListProvider } from "../../providers/TodoListProvider.js";
import { Status as Status$1 } from "../../todo-list.types.js";
import TooltipWrapper from "../TooltipWrapper/TooltipWrapper.js";
import { Container, StatusBox, Text, ArrowDownIcon, Info } from "./Status.styles.js";
import "@mui/material";
import "@mui/icons-material";
import "@mui/material/styles";
const Status = ({ todo, onClick, status, isReadonly }) => {
  const { labels, onTodo } = useTodoListProvider();
  const handleClick = useCallback(
    (event) => {
      event.stopPropagation();
      if (isReadonly)
        return;
      onClick(event.currentTarget);
      onTodo(todo);
    },
    [isReadonly]
  );
  const statusLabel = useMemo(() => {
    switch (status) {
      case Status$1.TO_DO:
      case Status$1.IN_PROGRESS:
        return labels.status.todo;
      case Status$1.IGNORED:
        return labels.comment.ignore;
      case Status$1.RECALLED:
        return labels.status.recall;
      case Status$1.DONE:
        return labels.status.done;
      default:
        return "";
    }
  }, [todo, labels, status]);
  return /* @__PURE__ */ jsxs(Container, { "data-testid": TodoDataTestIds.TodoStatusContainer, children: [
    /* @__PURE__ */ jsxs(
      StatusBox,
      {
        "data-testid": TodoDataTestIds.TodoStatus,
        readonly: isReadonly ?? false,
        state: status ?? "",
        onClick: handleClick,
        children: [
          /* @__PURE__ */ jsx(Text, { "data-testid": TodoDataTestIds.TodoStatusLabel, state: status ?? "", children: statusLabel }),
          !isReadonly && /* @__PURE__ */ jsx(ArrowDownIcon, { "data-testid": TodoDataTestIds.TodoStatusArrow })
        ]
      }
    ),
    todo.status === Status$1.IGNORED && todo.ignoreComment && /* @__PURE__ */ jsx(TooltipWrapper, { title: todo.ignoreComment, children: /* @__PURE__ */ jsx(Info, { "data-testid": TodoDataTestIds.TodoStatusComment }) })
  ] });
};
export {
  Status as default
};
